import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as dms from '../../../../dms'
import * as organizations from '../../../organizations'
import type * as jobTitles from '../../job-titles'
import type { Collection } from '../collection'

/**
 * Loads the job titles and organizations whenever the people are loaded, since
 * this collection serves only the people themselves while the Title and
 * organization columns present those by name.
 */
export const loadJobTitlesAndOrganizationsOnListLoad = store.effects.create(
  (
    _feature: Collection['feature'],
    collection: Collection,
    jobTitlesEc: jobTitles.Collection,
    organizationsFeature: organizations.Feature,
    schemaFeature: dms.schema.Feature,
  ) =>
    collection.plugins.currentListPlugin.feature.actions.load.request
      .observe()
      .pipe(
        rxjsUtils.latestFrom(
          action => ({
            action: rxjs.of(action),
            schema: schemaFeature.selectors.schema.asObservable,
          }),
          ({ schema }) => schema.areModelsInitialized,
        ),
        rxjs.switchMap(({ action, schema }) =>
          rxjs
            .from([
              jobTitlesEc,
              ...schema
                .getEntitiesInDimension(organizations.constants.DIMENSION_ID)
                .map((entity: ents.core.dms.models.Entity) =>
                  organizationsFeature.selectors
                    .getOrganizationEc(entity.id)
                    .asSignal(),
                )
                .filter(TypeChecker.isNotNullish.raw),
            ])
            .pipe(
              rxjs.map(relatedEc =>
                relatedEc.plugins.currentListPlugin.feature.actions.load
                  .from(action)
                  .create(),
              ),
            ),
        ),
      ),
)
